import { useNavigate } from 'react-router-dom'
import { AccountType } from '@/common/types'
import { ChevronRight } from 'lucide-react'
import { NAVIGATION_COPY } from '@/locales/en'
import { Button } from '@/common/ui/button'
import { getAvailableTabs, TAB_TO_ROUTE } from '../tabs'
import type { AccountTabKey } from '../types'

type Props = {
    accountType?: AccountType
}

export default function MobileTabMenu({ accountType }: Props) {
    const navigate = useNavigate()
    const copy = NAVIGATION_COPY.account
    const availableTabs = getAvailableTabs(accountType)

    const onSelectTab = (tab: AccountTabKey) => {
        navigate(TAB_TO_ROUTE[tab])
    }

    return (
        <div className="self-stretch flex flex-col justify-start items-start gap-4 md:px-6">
            {availableTabs.map((tab) => (
                <div key={tab} className="self-stretch flex flex-col justify-start items-start gap-3 md:gap-4">
                    <Button
                        variant="link"
                        aria-label={`Select ${tab} tab`}
                        innerClassName="w-full justify-between"
                        midClassName="w-full"
                        className="w-full px-0 py-0 h-8"
                        onClick={() => onSelectTab(tab)}
                    >
                        <div className="inline-flex flex-col justify-start items-start gap-1">
                            <div className="justify-start text-content-primary text-base font-normal leading-6">
                                {
                                    copy.tabs[
                                        tab === 'account'
                                            ? 'accountDetails'
                                            : tab === 'settings'
                                              ? 'accountSettings'
                                              : 'accountHolders'
                                    ]
                                }
                            </div>
                        </div>
                        <ChevronRight size={24} className="text-content-secondary" />
                    </Button>
                    <div className="self-stretch h-0 border-t border-border-divider" />
                </div>
            ))}
        </div>
    )
}
